import type { FC } from "preact/compat";
import type { TextFieldProps } from "./interfaces";
import cn from "classnames";

const TextField: FC<TextFieldProps> = ({
    className,
    leftIcon,
    rightIcon,
    disabled,
    ...rest
}) => (
    <div
        className={cn(
            "relative flex border border-gray-300 rounded-3xl items-center transition duration-100",
            "focus-within:ring-2 focus-within:ring-sky-500 focus-within:ring-offset-2 focus-within:ring-offset-white",
            disabled && "bg-gray-100",
            className && String(className)
        )}
    >
        <input
            className={cn(
                "peer w-full h-full px-4 py-[5px] border-none rounded-3xl outline-none focus:caret-sky-500 transition duration-100",
                "disabled:placeholder:text-gray-300",
                leftIcon && "pl-7",
                rightIcon && "pr-7"
            )}
            disabled={disabled}
            {...rest}
        />
        {leftIcon && (
            <span className="absolute w-4 h-4 text-gray-500 peer-disabled:text-gray-300 transition duration-100 left-2 peer-focus:text-sky-500">
                {leftIcon}
            </span>
        )}
        {rightIcon && (
            <span className="absolute w-4 h-4 text-gray-500 peer-disabled:text-gray-300 transition duration-100 right-2 peer-focus:text-sky-500">
                {rightIcon}
            </span>
        )}
    </div>
);

export default TextField;
